import { render, staticRenderFns } from "./ReportsPresentationsCard.vue?vue&type=template&id=809a0086"
import script from "./ReportsPresentationsCard.vue?vue&type=script&lang=js"
export * from "./ReportsPresentationsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports